import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          糖心视频、黑桃视频、妖精视频等话题实时热度追踪
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href={`#topics`}
              onClick={(e) => e.preventDefault()}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-300 whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200/70 hover:bg-primary-100 text-primary-700'
                  : 'bg-background-50 border-background-200/70 hover:border-background-300 text-foreground-600 hover:text-foreground-800'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}